"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFuture = void 0;
var react_1 = __importStar(require("react"));
var crumbs_1 = require("../crumbs");
var layout_1 = require("./shared/layout");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var select_qihuo_chart_1 = require("./shared/select_qihuo_chart");
var zixun_1 = require("./shared/zixun");
var title_bar_1 = require("./shared/title_bar");
var title_qihuotable_1 = require("./shared/title/title_qihuotable");
var user_1 = __importDefault(require("../../modules/user"));
/**
 * 期货首页
 */
function PageFuture() {
    var _this = this;
    var _a = (0, react_1.useState)(true), isLogin = _a[0], setIsLogin = _a[1];
    (0, react_1.useEffect)(function () {
        ;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); })();
        if (user_1.default.get() == null)
            setIsLogin(false);
    }, []);
    return (react_1.default.createElement("div", { className: "future" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(layout_1.Layout4, { mt: 5 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(select_qihuo_chart_1.QiHuoSelectMiniChart, { qihuomarket: "220", height: 180 }, "\u4E2D\u91D1\u6240")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(select_qihuo_chart_1.QiHuoSelectMiniChart, { qihuomarket: "113", height: 180 }, "\u4E0A\u671F\u6240")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(select_qihuo_chart_1.QiHuoSelectMiniChart, { qihuomarket: "142", height: 180 }, "\u4E0A\u671F\u80FD\u6E90")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(select_qihuo_chart_1.QiHuoSelectMiniChart, { qihuomarket: "114", height: 180 }, "\u5927\u5546\u6240"))),
        react_1.default.createElement(layout_1.Layout4, { mt: 5 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(select_qihuo_chart_1.QiHuoSelectMiniChart, { qihuomarket: "115", height: 180 }, "\u90D1\u5546\u6240")),
            react_1.default.createElement(layout_1.Layout4.Item, null, isLogin ?
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "101.GC00Y", height: 180, border: false },
                    react_1.default.createElement("a", { href: "//quote.eastmoney.com/globalfuture/GC00Y.html" }, "COMEX\u9EC4\u91D1"))
                :
                    react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "112.B00Y", height: 180, border: false },
                        react_1.default.createElement("a", { href: "//quote.eastmoney.com/globalfuture/B00Y.html" }, "\u5E03\u4F26\u7279\u539F\u6CB9"))),
            react_1.default.createElement(layout_1.Layout4.Item, null, isLogin ?
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "102.CL00Y", height: 180, border: false },
                    react_1.default.createElement("a", { href: "//quote.eastmoney.com/globalfuture/CL00Y.html" }, "NYMEX\u539F\u6CB9"))
                :
                    react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "112.M00Y", height: 180, border: false },
                        react_1.default.createElement("a", { href: "//quote.eastmoney.com/globalfuture/M00Y.html" }, "\u5929\u7136\u6C14"))),
            react_1.default.createElement(layout_1.Layout4.Item, null, isLogin ?
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "101.HG00Y", height: 180, border: false },
                    react_1.default.createElement("a", { href: "//quote.eastmoney.com/globalfuture/HG00Y.html" }, "COMEX\u94DC"))
                :
                    react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "104.CN00Y", height: 180, border: false },
                        react_1.default.createElement("a", { href: "//quote.eastmoney.com/globalfuture/CN00Y.html" }, "A50\u671F\u6307\u5F53\u6708\u8FDE\u7EED")))),
        react_1.default.createElement(title_bar_1.TitleBar, { mt: 10 },
            react_1.default.createElement(title_bar_1.TitleBar.Title, null,
                react_1.default.createElement("a", { href: "//futures.eastmoney.com/news/cqhdd.html" }, "\u671F\u8D27\u5BFC\u8BFB")),
            react_1.default.createElement(title_bar_1.TitleBar.Content, null,
                react_1.default.createElement(zixun_1.ColumnNewsScroll, { columns: "765" }))),
        react_1.default.createElement(layout_1.Layout2, { mt: 0 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(QHChildTable, { tit: "\u91D1\u878D\u671F\u8D27", link: "gridlist.html#futures_finance", orderdur: 'desc', blockName: "financial" })),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(QHChildTable, { tit: "\u80FD\u6E90\u5316\u5DE5", link: "gridlist.html#futures_energy", orderdur: 'desc', blockName: "energy" }))),
        react_1.default.createElement(layout_1.Layout2, { mt: 10 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(QHChildTable, { tit: "\u91D1\u5C5E\u94A2\u6750", link: "gridlist.html#futures_metal", orderdur: 'desc', blockName: "metal" })),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(QHChildTable, { tit: "\u519C\u4EA7\u54C1\u98DF\u54C1\u539F\u6599", link: "gridlist.html#futures_farmproduce", orderdur: 'desc', blockName: "agricultural" })))));
}
exports.PageFuture = PageFuture;
/**
 * 期货middle table
 * @param props
 * @returns
 */
function QHChildTable(props) {
    return (react_1.default.createElement(title_qihuotable_1.Title1QiHuoTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: props.link }, "\u66F4\u591A>>")), table_key: 'qihuo_small',
        blockName: props.blockName,
        count: 5,
        order: 'zdf',
        orderdur: 'desc' },
        react_1.default.createElement("a", { href: props.link, target: "_blank" }, props.tit)));
}
